/* eslint import/first: 0 */
/* eslint import/newline-after-import: 0 */
/* eslint no-multi-assign: 0 */
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import { analytics } from '@/services/segment/segment';
import { userService } from '@/services/userService/UserService';
import { mixPanelService } from '@/services/MixPanelService';
import {pendo} from "@/services/pendoService/pendo";
import _ from 'lodash';

import './bootstrap';

import Vue from 'vue';
import Bugsnag from '@/common/Bugsnag';
import Enum from 'enum';
import Utils from '@/util/Utils';

window.Vue = Vue;

// Plugins

window.Enum = Enum;
window.userService = userService;

import VueMask from 'v-mask';

Vue.use(VueMask);

import VueBrowserUpdate from 'vue-browserupdate';
import VueBrowserUpdateOptions from '@/common/VueBrowserUpdateOptions';
import VueMixpanel from 'vue-mixpanel';
import moment from 'moment';
import momentTz from 'moment-timezone';
import { isAndroid } from 'v-mask/src/utils/env';

import { createPinia, PiniaVuePlugin } from 'pinia';

// Init Pinia store.
Vue.use(PiniaVuePlugin);
const pinia = createPinia();

import '@styles/shiftkey.scss';

window.isAndroid = isAndroid;
window.moment = moment;
moment.tz.setDefault('UTC');
if (!import.meta.env.VITE_APP_ENV.includes('e2e')) {
  if (userService.userData !== undefined) {
    window.pendo.initialize({
      visitor: {
        id: import.meta.env.VITE_APP_ENV === 'prod' ? userService.userData.id : `${import.meta.env.VITE_APP_ENV}-${userService.userData.id}`,
        email: userService.userData.email,
        role: userService.userData.role,
      },

      account: {
        id: userService.userData.id,
      },
    });
  }
}

Vue.use(VueBrowserUpdate, VueBrowserUpdateOptions);
Vue.use(VueMixpanel, {
  token: import.meta.env.VITE_MIX_PANEL_TOKEN,
});
Bugsnag.init();

// Vuetify

import Vuetify from 'vuetify/lib';
import { Resize, Ripple } from 'vuetify/lib/directives';
import VuetifyInit from '@/common/vuetifyInit';
import Apptimize from '@apptimize/apptimize-web-sdk';

Vue.use(Vuetify, {
  directives: {
    Resize,
    Ripple,
  },
});

// Buses

import { BusyUIBus } from './eventBuses/BusyUIBus';
import { ErrorBus } from './eventBuses/ErrorBus';
import { EventBus } from './eventBuses/EventBus';
import { ModalBus } from './eventBuses/ModalBus';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import MobileHelper from '@/util/MobileHelper';
import axios from 'axios';

Vue.mixin({
  data() {
    return {
      buses: {
        busyUI: BusyUIBus,
        error: ErrorBus,
        event: EventBus,
        modal: ModalBus,
      },
      currentUser: userService,
      utils: Utils,
    };
  },
});

// reCAPTCHA
if (import.meta.env.VITE_RECAPTCHA_ON === 'true') {
  Vue.use(VueReCaptcha, {
    siteKey: import.meta.env.VITE_RECAPTCHA_SITE_KEY,
    loaderOptions: {
      explicitRenderParameters: {
        badge: 'bottomleft',
      },
    },
  });
}

// Component Registration

Vue.component('action-buttons', () => import('./vues/components/common/ActionButtons.vue'));
Vue.component('alert', () => import('./vues/components/pre-vuetify/Alert.vue'));
Vue.component('credentials-root', () => import('./vues/CredentialsRoot.vue'));
Vue.component('plaid-idv-root', () => import('./vues/PlaidIdvRoot.vue'));
Vue.component('acute-care-webview-todos-root', () => import('./vues/AcuteCareWebviewTodosRoot.vue'));
Vue.component('acute-care-webview-facility-tasks-root', () => import('./vues/AcuteCareWebviewFacilityTasksRoot.vue'));
Vue.component('acute-care-webview-facility-unit-tasks-root', () => import('./vues/AcuteCareWebviewFacilityUnitTasksRoot.vue'));
Vue.component('mobile-upload-root', () => import('./vues/MobileUploadRoot.vue'));
Vue.component('modal-shiftkey-root', () => import('./vues/components/common/ModalShiftkeyRoot.vue'));
Vue.component('on-boarding-root', () => import('./vues/OnBoardingRoot.vue'));
Vue.component('public-credentials-root', () => import('./vues/PublicCredentialsRoot.vue'));
Vue.component('register', () => import('./vues/Register.vue'));

// eslint-disable-next-line no-unused-vars
const app = new Vue({
  vuetify: VuetifyInit,
  el: '#app',
  data: {
    apptimizeInited: false,
  },
  pinia,
});

axios.interceptors.request.use((config) => {
  if (window.impersonated && window.impersonatedReadOnlyAccess && config.method !== 'get') {
    app.buses.error.emitError({
      headline: 'Impersonate read-only',
      message: `<p>You're in impersonate read-only mode. You can't modify any of the user data.</p>`
    });
    return;
  }
  return config;
});

mixPanelService.app = app;
// Apptimize
Apptimize.setOnApptimizeInitializedCallback(() => {
  app.apptimizeInited = true;
  app.$emit('apptimizeInitialized');
});
Apptimize.setup(import.meta.env.VITE_APPTIMIZE_APP_KEY);
if (userService.userData?.id) {
  Apptimize.setCustomerUserId(userService.userData.id.toString());
  Apptimize.setCustomAttributes({
    id: userService.userData.id,
    role: userService.userData?.role,
    home_base_state: userService.userData?.home_base?.zip_code_info?.state?.abbreviation,
  });
  analytics.user().then((user) => {
    user.traits({});

    analytics.identify(userService.userData.id, {
      email: userService.userData.email,
      first_name: userService.userData.first_name,
      last_name: userService.userData.last_name,
      role: _.kebabCase(userService.userData.role.toLowerCase()),
      roles: userService.userData.roles,
    });
  });
}
